import React from 'react'
import logo from '../../img/pokerlistingscomlogo.svg'
import './style.scss'

export default class Loader extends React.PureComponent{

    constructor(props) {
        super(props);
        this.state = {
            isImgLoaded:false,
            isWindowLoaded: false,
            isAppLoaded: false,
            elapsed: 0
        };

        this.tick = this.tick.bind(this);
        this.timer = setInterval(this.tick, 10);

        let onImgLoad = this.onImgLoad.bind(this);
        this.handleWindowLoad = this.handleWindowLoad.bind(this);
        this.handleAppLoad = this.handleAppLoad.bind(this);

        let req = require.context('../../img', true, /.*/);
        let images = req.keys().map((key) => {return req(key)});
        let imagesDom = [];
        let imageQueue = [logo].reverse();
        imageQueue.forEach(img => {
            let index = images.indexOf(img);
            if (index !== -1) {
                images.splice(index, 1)
            }
            images.push(img);
        });
        images.reverse();

        images.forEach(function(filePath) {
            let img = new Image();
            img.setAttribute('path', filePath);
            img.src = filePath;
            imagesDom.push(img);
            img.addEventListener('load', function() {
                let index = images.indexOf(this.getAttribute('path'));
                index !== -1 ? images.splice(index, 1) : console.log('Image was not founded: ' + this.getAttribute('path'));
                if (images.length === 0) {
                    onImgLoad();
                }
            });

        });
    }

    onImgLoad() {
        this.setState({isImgLoaded:true});
        this.handleAppLoad();
    }

    tick() {
        this.setState({elapsed: new Date() - this.props.start});
    }

    componentDidMount() {
        window.addEventListener('load', this.handleWindowLoad);
    }

    handleWindowLoad() {
        this.setState({isWindowLoaded: true});
        this.handleAppLoad();
    }

    handleAppLoad() {
        if(this.state.isImgLoaded && this.state.isWindowLoaded) {
            const currentTime = (Math.round(this.state.elapsed / 100) / 10).toFixed(1);
            if (currentTime < 2) {
                setTimeout(()=> this.handleAppLoad(), (2-currentTime)*1000)
            } else {
                this.setState({isAppLoaded: true});
                clearInterval(this.timer);
            }
        }
    }

    render() {
        const display = {
            app: {
                visibility: this.state.isAppLoaded ? 'visible' : 'hidden',
                height: '100%',
            },
            loader: {
                display: !this.state.isAppLoaded ? 'flex' : 'none',
            }
        };

        return (
            <div style={{height:'100%'}}>
                <div style={display.app}>{this.props.children}</div>
                <div className={'loader'} style={display.loader}>
                    <div className={'loader-content_wrapper'}>
                        <div className="logo-container">
                            <img src={logo} alt=""/>
                        </div>
                        <div className="lds-dual-ring"/>
                    </div>
                </div>
            </div>
        );
    }

}
